import * as React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';

import FormikInput from 'components/common/FormikInput';
import { Input } from 'components/bootstrap';
import { TimezoneSelect } from 'components/common';
import HoverForHelp from 'components/common/HoverForHelp';

type Props = {
  editAllowed: boolean;
  scopeLocked?: boolean;
};

const DescriptionTextArea: React.ComponentType<React.ComponentProps<typeof FormikInput>> = styled(FormikInput)`
  resize: vertical;
`;

const timezoneLabel = (
  <>
    Time zone
    <HoverForHelp iconSize="sm" title="Time zone" placement="right">
      The time zone selected here will be used to display all times in the report.
    </HoverForHelp>
  </>
);

const Overview = ({ editAllowed, scopeLocked = false }: Props) => {
  // Reports under a scope-locked entity scope (e.g. Illuminate) lock title/subtitle/description.
  const lockedByScope = !editAllowed || scopeLocked;

  return (
  <>
    <FormikInput label="Title" name="title" id="title" required disabled={lockedByScope} />
    <FormikInput
      label={
        <>
          Subtitle <small className="text-muted">(Optional)</small>
        </>
      }
      name="subtitle"
      id="subtitle"
      disabled={lockedByScope}
    />
    <DescriptionTextArea
      type="textarea"
      rows={3}
      label={
        <>
          Description <small className="text-muted">(Optional)</small>
        </>
      }
      name="description"
      id="description"
      disabled={lockedByScope}
    />
    <Field name="timezone">
      {({ field: { name, value, onChange } }) => (
        <Input id="timezone-select" label={timezoneLabel} disabled={!editAllowed}>
          <TimezoneSelect
            value={value}
            name="timezone"
            onChange={(newValue: string) => onChange({ target: { name, value: newValue } })}
            disabled={!editAllowed}
          />
        </Input>
      )}
    </Field>
  </>
  );
};

export default Overview;
